import { render, staticRenderFns } from "./SavedSearches.vue?vue&type=template&id=7cec3760&scoped=true&"
import script from "./SavedSearches.vue?vue&type=script&lang=js&"
export * from "./SavedSearches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cec3760",
  null
  
)

export default component.exports